import React from 'react';
import PropTypes from 'prop-types';
import { List, Row, Col } from 'antd';
import {
  Link,
  TimeWithTimeZone,
  WorksAvatar,
  Icon,
  Gutter,
} from '@common/components';
import { AntBreakpoints, Colors, Spacing } from 'works/legacy/lib/style-helper';
import StateArea from 'works/pages/organization/applications/state-area/state-area';

function formatStaffingRequestApplication(staffingRequestApplication) {
  const dataHash = {};
  const worksProfile = staffingRequestApplication.worksProfile;

  const firstName = worksProfile.firstName;
  const lastName = worksProfile.lastName;
  const fullName = worksProfile.fullName;

  dataHash['supplier'] = staffingRequestApplication.supplier;
  dataHash['state'] = staffingRequestApplication.state;
  dataHash['key'] = staffingRequestApplication.id;
  // Alias attribute for GraphQL queries
  dataHash['id'] = staffingRequestApplication.id;
  dataHash['firstName'] = firstName;
  dataHash['lastName'] = lastName;
  dataHash['title'] = fullName;
  dataHash['profilePic'] = worksProfile.profilePic;
  dataHash['createdAt'] = staffingRequestApplication.createdAt;

  dataHash['profileSummary'] = worksProfile.profileSummary;
  dataHash['rejectionReasonDescription'] =
    staffingRequestApplication.rejectionReasonDescription;
  dataHash['rejectionDetails'] = staffingRequestApplication.rejectionDetails;
  dataHash['createdByName'] = staffingRequestApplication?.createdBy?.name;
  dataHash['createdByEmail'] = staffingRequestApplication?.createdBy?.email;
  dataHash['showCreatedByInfo'] =
    dataHash.createdByName &&
    dataHash.createdByEmail &&
    dataHash.state === 'submitted';
  return dataHash;
}

export function CandidateListItem(props) {
  const item = formatStaffingRequestApplication(props.item);
  const staffingRequest = props.staffingRequest;
  const offer = props.item.activeOffer;

  let backgroundColor = 'transparent';

  if (item.state === 'rejected' || item.state === 'withdrawn') {
    backgroundColor = Colors.steelLightest;
  }

  if (staffingRequest.state === 'ON_HOLD') {
    backgroundColor = Colors.sunLightest;
  }

  return (
    <div className="CandidateListItem">
      <List.Item>
        <Row gutter={24} className="candidate-list-row">
          <Col className="avatar-col sentry-mask">
            <Link
              to={`/works/staffing_requests/${staffingRequest.id}/candidates/${item.key}`}
            >
              <WorksAvatar
                avatarImageSrc={item.profilePic}
                firstName={item.firstName}
                lastName={item.lastName}
                size={116}
              />
            </Link>
          </Col>

          <Col xs={24} md={7} lg={7}>
            <div className="candidate-name-link sentry-mask">
              <Link
                to={`/works/staffing_requests/${staffingRequest.id}/candidates/${item.key}`}
              >
                {item.title}
              </Link>
            </div>

            <div className="submission-time">
              Submitted{' '}
              <TimeWithTimeZone date={item.createdAt} variant="mid_format" />
              {item.showCreatedByInfo &&
                ` by ${item.createdByName} <${item.createdByEmail}>`}
            </div>

            {item.supplier && (
              <>
                <Gutter direction="right" size="xs" fit>
                  <Icon icon="building" kind="light" size="md" />
                </Gutter>{' '}
                <strong>{item.supplier.name}</strong>
              </>
            )}

            <div className="application-summary">{item.profileSummary}</div>
          </Col>
          <Col xs={0} md={13} lg={13}>
            <StateArea
              application={props.item}
              offer={offer}
              staffingRequest={staffingRequest}
            />
          </Col>
        </Row>
      </List.Item>

      <style jsx>{`
        .CandidateListItem :global(.candidate-name-link > a) {
          font-size: 24px;
          font-weight: 800;
          margin-bottom: ${Spacing.baseSpacing / 4}px;
        }
        .CandidateListItem {
          width: 100%;
          background-color: ${backgroundColor};
        }
        .CandidateListItem:hover {
          background-color: ${Colors.elmHyperlight} !important;
        }
        .CandidateListItem :global(.ant-list-item) {
          line-height: 24px;
          border-bottom: 1px solid ${Colors.steel};
          padding: ${Spacing.baseSpacingPx};
          margin-bottom: 0;
          margin-top: 0;
        }
        .CandidateListItem :global(.avatar-col) {
          flex: 0 0 80px;
        }
        @media (max-width: ${AntBreakpoints.mdPx}) {
          .CandidateListItem :global(.avatar-col) {
            display: none;
          }
        }
        .submission-time {
          font-size: 12px;
          color: ${Colors.midnightLighter};
        }
        .application-summary {
          color: ${Colors.midnightLighter};
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 4;
          -webkit-box-orient: vertical;
        }
        .fa-ul {
          margin: 4px 0 4px 23px;
        }
      `}</style>
    </div>
  );
}

CandidateListItem.propTypes = {
  item: PropTypes.object,
  staffingRequest: PropTypes.object,
};
